'use strict';

var template = require('../../templates/dashboard/ActionLog.ejs');
var ContentView = require('commons/views/ActionLog');

module.exports = Backbone.View.extend({
    initialize: function(options) {
        this.fetchMore = options.fetchMore;
    },

    render: function() {
        this.$el.html(template({}));
        this.hideLoader();
        this.renderContent();
        return this;
    },

    renderContent: function() {
        this.$('.js-action-log-content').html(new ContentView({
            collection: this.collection,
            fetchMore: this.fetchMore
        }).render().el);
        this.undelegateEvents();
        this.delegateEvents();
    },

    hideLoader: function() {
        this.$('.js-loader').hide();
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/dashboard/ActionLog.js